import { UPLOAD_FOLDER_MEDIA } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPLOAD_FOLDER_MEDIA.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_FOLDER_MEDIA.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPLOAD_FOLDER_MEDIA.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
